import { Link, useLocation } from "react-router-dom";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

export function NavSecondary({ items, onItemClick, ...props }) {
  const { pathname } = useLocation();

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => {
            const isActive = item.url ? pathname === item.url : false;
            const Icon = item.icon;

            return (
              <SidebarMenuItem key={item.title}>
                {item.url ? (
                  <SidebarMenuButton asChild isActive={isActive}>
                    {item.external ? (
                      <a href={item.url} target="_blank" rel="noreferrer">
                        {Icon ? <Icon className={cn(item.iconClassName)} /> : null}
                        <span>{item.title}</span>
                      </a>
                    ) : (
                      <Link to={item.url}>
                        {Icon ? <Icon className={cn(item.iconClassName)} /> : null}
                        <span>{item.title}</span>
                      </Link>
                    )}
                  </SidebarMenuButton>
                ) : (
                  <SidebarMenuButton
                    type="button"
                    onClick={() => onItemClick?.(item.title)}
                  >
                    {Icon ? <Icon className={cn(item.iconClassName)} /> : null}
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                )}
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
